import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { PAGELENGTH } from 'components/common/ListLayout';
import Api from "services/api"


export const initialState = {
  jurisdiction: [],
  error: null,
  loader: false,
  featured: {},
  total: 0,
  is_more: false,
  last_page: 1,
  current_page: 1,
  per_page: PAGELENGTH,
}

export const jurisdictionSlice = createSlice({
  name: 'jurisdiction',
  initialState: initialState,
  reducers: {
    setJurisdiction: (state, { payload }) => {
      state.jurisdiction = payload?.data ?? payload;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setJurisdictions: (state, { payload }) => {
      state.jurisdiction = payload?.data;
      state.total = payload?.total;
      state.is_more = payload?.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    setMoreJurisdictions: (state, { payload }) => {
      state.data = state.data.concat(payload.data);
      state.total = payload.total;
      state.is_more = payload.is_more;
      state.last_page = payload?.last_page;
      state.current_page = payload?.current_page;
      state.per_page = payload?.per_page;
    },
    removeJurisdiction: (state, { payload }) => {
      state.error = payload
    },
    clearAllJurisdiction: (state, { payload }) => {
      state.loader = payload
    },
    setError: (state, { payload }) => {
      state.error = payload
    },
    setLoader: (state, { payload }) => {
      state.loader = payload
    },
  }
})

export const addJurisdiction = (data, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.addJurisdiction(data)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
  }
  dispatch(setLoader(false))
}

export const updateJurisdiction = (data, itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.updateJurisdiction(data, itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
  }
  dispatch(setLoader(false))
}

export const removeJurisdiction = (itemId, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeJurisdiction(itemId)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
  }
  dispatch(setLoader(false))
}
export const fetchJurisdictions = (page, params, disableLoader, Aync) => async (dispatch) => {
  !disableLoader && dispatch(setLoader(true))
  try {

    const result = await Api.fetchJurisdictions(page, params)
    if (result.status >= 200 && result.status < 300) {
      if (page > 1) {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setJurisdictions(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      } else {
        if (Aync) {
          return result?.data?.data;
        } else {
          dispatch(setJurisdictions(result.data.data));
          !disableLoader && dispatch(setLoader(false))
        }
      }
    }
    else if (result?.status == 422) {
      if (Aync) {
        return [];
      } else {
        dispatch(setError(result.data))
        !disableLoader && dispatch(setLoader(false))
      }
    }
  } catch (error) {
    console.log("error", error)
  }
}


export const changeStatus = (id, data) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.statusChange(id, data, 'jurisdictions')
    if (json.status >= 200 && json.status < 300) {
    } else if (json.status == 422) {
      dispatch(setError(json.data))
    }
  } catch (error) {
    console.log(error)
  }
  dispatch(setLoader(false))
}

export const removeMultipleJurisdictions = (ids, callback) => async (dispatch) => {
  const apiService = new Api();
  dispatch(setError({}))
  dispatch(setLoader(true))
  try {

    const json = await Api.removeMultipleJurisdictions(ids)
    if (json.status >= 200 && json.status < 300) {
      console.log(json)
      callback(true, json.data.message)
    } else if (json.status == 422) {
      dispatch(setError(json.data))
      callback(false, json.data.message)
    }
  } catch (error) {
    console.log(error)
  }
  dispatch(setLoader(false))
}

export const { setJurisdiction, setJurisdictions, clearAllJurisdiction, setLoader, setError, setMoreJurisdictions } = jurisdictionSlice.actions


export default jurisdictionSlice.reducer
export const jurisdictionSelector = state => state.jurisdiction
